import { Radio, RadioGroup } from '@mui/material';
import { CardSection, CardSubSection, Tile, useIsMobile } from '@side/pantry';
import { Controller, useFormContext } from 'react-hook-form';
import {
  BuyerMethod,
  buyerMethodOptions,
  type CreateOfferFormData,
} from '../types';

export const BuyerTypeSection = () => {
  const { control } = useFormContext<CreateOfferFormData>();
  const isMobile = useIsMobile('md');

  return (
    <CardSection cardTitle="Buyer Type">
      <CardSubSection>
        <Controller
          name="buyerMethod"
          control={control}
          render={({ field }) => (
            <RadioGroup
              {...field}
              value={field.value ?? null}
              aria-label="Buyer Type"
              sx={{
                flexWrap: 'nowrap',
                flexDirection: { xs: 'column', md: 'row' },
                gap: { xs: 2, md: 3 },
              }}
            >
              {Object.values(BuyerMethod).map((method) => (
                <Tile
                  key={method}
                  value={method}
                  label={buyerMethodOptions[method].label}
                  description={buyerMethodOptions[method].description}
                  hideIcon={!isMobile}
                  control={<Radio />}
                  sx={{ m: 0, flex: 1 }}
                />
              ))}
            </RadioGroup>
          )}
        />
      </CardSubSection>
    </CardSection>
  );
};
